import { mainPageAnimation } from './main-page.animation';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { merge, of, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { BackgroundPlayerComponent, HappyHoursService, InteractionService, WidgetUiConfigRef } from '@core';
import { ConfettiComponent } from '@app/components/confetti/confetti.component';
import { TabBarComponent } from '@app/components/tab-bar/tab-bar.component';

@Component({
  selector: 'app-page-main',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  animations: [
    mainPageAnimation,
  ],
  imports: [
    ConfettiComponent,
    RouterOutlet,
    TabBarComponent,
    BackgroundPlayerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {

  public readonly showConfetti$ = this.happyHoursService.isNow$.pipe(
    switchMap((status) => {
      if (!status) {
        return of(false);
      }

      return merge(
        of(true),
        timer(4500).pipe(map(() => false)),
      );
    }),
  );

  public readonly showConfetti = toSignal(this.showConfetti$, {
    initialValue: false,
  });

  public readonly userInteracts = toSignal(this.interaction.status$, {
    initialValue: false,
  });

  constructor(
    private readonly interaction: InteractionService,
    private readonly widgetUiConfig: WidgetUiConfigRef,
    private readonly happyHoursService: HappyHoursService,
  ) {}

  get widgetUi(): WidgetUiConfigRef {
    return this.widgetUiConfig;
  }

  public prepareRoute(outlet: RouterOutlet): unknown {
    return outlet?.activatedRouteData['animation'];
  }

}
